import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllContasPagarDeletadasUseCase } from "../../../presentation/useCases/read/get_all_contas_pagar_deletadas_use_case";
import { ContasPagarLista } from "../../models/contas_pagar_lista";
import { ContasPagarListaFilter } from "../../models/contas_pagar_lista_filter";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetAllContasPagarDeletadasUseCase
 */

export class GetAllContasPagarDeletadasUseCase extends BasePaginatedUseCase<ContasPagarLista> implements IGetAllContasPagarDeletadasUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllContasPagarDeletadas(
    filter: ContasPagarListaFilter,
    currentPage: number,
    rowsPerPage: number
  ): Promise<void> {
    const response = await this.repository.getAllContasPagarDeletadas(filter, currentPage, rowsPerPage);

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;

  }
}
